module.exports = __webpack_public_path__ + "img/youtube-play.7a936ea0.svg";